import React, { useState, useEffect } from "react";

export default function RoyalEntranceSplash() {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Progress bar fill animation
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 5;
      });
    }, 45);

    // Fade out splash after progress completes
    const timer1 = setTimeout(() => {
      setFadeOut(true);
    }, 1250);

    // Hide overlay completely from DOM
    const timer2 = setTimeout(() => {
      setLoading(false);
    }, 1850);

    return () => {
      clearInterval(interval);
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  if (!loading) return null;

  return (
    <div className={`hk-splash-overlay ${fadeOut ? "hk-splash-overlay--fade" : ""}`}>
      {/* Background Ambient Radial Glow */}
      <div className="hk-splash-glow" />

      {/* Main Royal Crest & Branding */}
      <div className="hk-splash-content">
        <div className="hk-splash-crown-wrapper">
          <i className="fas fa-crown hk-splash-crown-icon" />
        </div>

        <h1 className="hk-splash-title">HARI KUNJ</h1>
        <span className="hk-splash-subtitle">RESORT • JODHPUR</span>

        <p className="hk-splash-tagline">Experience Regal Luxury in Rajasthan</p>

        {/* Minimal Gold Progress Line */}
        <div className="hk-splash-progress-track">
          <div className="hk-splash-progress-bar" style={{ width: `${progress}%` }} />
        </div>
      </div>

      <style>{`
        .hk-splash-overlay {
          position: fixed;
          inset: 0;
          z-index: 999999;
          background: linear-gradient(135deg, #050E1A 0%, #0B1D37 50%, #050E1A 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          transition: transform 0.75s cubic-bezier(0.77, 0, 0.175, 1), opacity 0.65s ease, filter 0.65s ease;
          user-select: none;
        }

        .hk-splash-overlay--fade {
          transform: translateY(-100%);
          opacity: 0;
          pointer-events: none;
        }

        .hk-splash-glow {
          position: absolute;
          width: 450px;
          height: 450px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(254, 161, 22, 0.22) 0%, rgba(212, 175, 55, 0.08) 45%, transparent 70%);
          animation: hk-pulse-glow 3s ease-in-out infinite alternate;
          pointer-events: none;
        }

        @keyframes hk-pulse-glow {
          0% { transform: scale(0.85); opacity: 0.6; }
          100% { transform: scale(1.15); opacity: 1; }
        }

        .hk-splash-content {
          position: relative;
          z-index: 10;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 20px;
          animation: hk-splash-zoom 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        @keyframes hk-splash-zoom {
          0% { opacity: 0; transform: scale(0.9) translateY(15px); }
          100% { opacity: 1; transform: scale(1) translateY(0); }
        }

        .hk-splash-crown-wrapper {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(254, 161, 22, 0.2), rgba(212, 175, 55, 0.2));
          border: 1.5px solid rgba(212, 175, 55, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 18px;
          box-shadow: 0 0 25px rgba(254, 161, 22, 0.4);
        }

        .hk-splash-crown-icon {
          font-size: 2rem;
          background: linear-gradient(135deg, #FEA116 0%, #D4AF37 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hk-splash-title {
          font-family: 'Cinzel', serif;
          font-size: 2.2rem;
          font-weight: 800;
          letter-spacing: 0.32em;
          color: #FAF6F0;
          margin: 0 0 6px 0;
          text-transform: uppercase;
          text-shadow: 0 4px 20px rgba(5, 14, 26, 0.8);
        }

        .hk-splash-subtitle {
          font-family: 'Poppins', sans-serif;
          font-size: 0.78rem;
          font-weight: 600;
          letter-spacing: 0.4em;
          color: #FEA116;
          margin-bottom: 14px;
        }

        .hk-splash-tagline {
          font-family: 'Playfair Display', serif;
          font-style: italic;
          font-size: 1.05rem;
          color: #d2c5b3;
          margin-bottom: 26px;
        }

        .hk-splash-progress-track {
          width: 220px;
          height: 3px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
          overflow: hidden;
          box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.5);
        }

        .hk-splash-progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #FEA116 0%, #D4AF37 100%);
          box-shadow: 0 0 10px rgba(254, 161, 22, 0.8);
          transition: width 0.08s linear;
        }

        @media (max-width: 576px) {
          .hk-splash-title {
            font-size: 1.7rem;
            letter-spacing: 0.25em;
          }
          .hk-splash-subtitle {
            font-size: 0.7rem;
            letter-spacing: 0.3em;
          }
          .hk-splash-tagline {
            font-size: 0.92rem;
          }
          .hk-splash-crown-wrapper {
            width: 60px;
            height: 60px;
          }
          .hk-splash-crown-icon {
            font-size: 1.6rem;
          }
        }
      `}</style>
    </div>
  );
}
